<template>
  <v-card style="height: 100% !important">

<div class="text-center">
    <v-dialog
      persistent
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline primary lighten-2">
          Content Not Available
        </v-card-title>

        <v-card-text>
          <p><br>
          This content is not currently available. If you believe that you are receiving this message in error, please contact the content author. 
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            onclick="javascript:window.history.back()"
          >
            Close this window
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>


    <v-main
      class="grey lighten-3"
      style="height: 91%; padding: 16px 0px 0px !important"
    >
      <v-container>
        <v-row>
          <v-col cols="12" sm="12">
            <v-card class="mx-auto" height="100%">
              <v-toolbar  dense :dark="theme">
                <v-avatar tile v-if="aspect_ratio==1">
                  <v-img
                  class="float-left"
                  lazy-src="@/assets/logo.png"
                  height="44"
                  contain
                  :aspect-ratio="aspect_ratio"
                  style="position:relative;"
                  :src="imgr"
                ></v-img>
                </v-avatar>
                <v-img v-else
                  class="float-left"
                  lazy-src="@/assets/logo.png"
                  height="44"
                  contain
                  :aspect-ratio="aspect_ratio"
                  style="'position:relative;"
                  :src="imgr"
                ></v-img>
                
                 
                <v-toolbar-title> </v-toolbar-title>
                <v-spacer class="d-none d-lg-block"></v-spacer
                ><v-spacer class="d-none d-lg-block"></v-spacer
                ><v-spacer class="d-none d-lg-block"></v-spacer>
                <v-spacer v-if="button2.show"></v-spacer>
                <v-spacer v-if="button2.show"></v-spacer>
                <v-spacer v-if="!button2.show && button1.show"></v-spacer>
                <v-btn
                  v-if="button1.show"
                  color="#27282A"
                  style="color:#fff;font-size:14pt;font-family:'Open Sans'"
                  class="mr-4"
                  @click="buttonInfo(button1)"
                  >{{ button1.label }}</v-btn
                >
                <v-btn
                  v-if="button2.show"
                  color="#27282A"
                  style="color:#fff;font-size:14pt;font-family:'Open Sans'"
                  class=""
                  @click="buttonInfo(button2)"
                  >{{ button2.label }}</v-btn
                >
              </v-toolbar>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <br><h2 style="color:#07293d;font-family:'Open Sans Bold';position:relative;" class="text-center">{{former.title}}</h2>
                    <div class="text-center" style="position:relative;top:12px;font-weight:400;color:#07293d">{{former.description}}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <SearchIndex v-bind:client="client" v-bind:mode="'production'" />
                  </v-col>
                </v-row>
                <v-row v-model="cards">
                  <v-col
                    id="sortable"
                    v-for="(card, idx) in cards"
                    :key="card.id"
                    :cols="computeColumns(card.flex, idx)"
                  >
                    <v-card height="100%" :class="card.bubba_class">
                      <v-img
                        v-if="card.include_gradient"
                        :src="card.src"
                        :class="card.bubba_class"
                        class="blue accent-1"
                        :height="75"
                      >
                        <v-card-title class="justify-center" v-text="card.title"></v-card-title>
                      </v-img>
                      <v-img v-else>
                        <v-card-title class="justify-center" v-text="former.title"></v-card-title>
                        <v-card-subtitle
                          v-text="former.description"
                        ></v-card-subtitle>
                      </v-img>

                      <v-list :dense="contentLength(card) > 6" class="justify-center" >
                        <v-subheader>{{ card.description }}</v-subheader>
                        <v-list-item-group class="justify-center"
                          v-model="selected_content"
                          color="primary"
                        >
                          <v-list-item
                            class="justify-center"
                            v-for="(contenter, index) in filterAware(card.content)"
                            :key="getKey(card.id, contenter.id)"
                            :value="getCardKey(card.id, contenter)"
                          >
                          <!--
                            <v-list-item-icon
                              v-if="index + 1 <= categoryBreakpoint()"
                            >
                            -->
                            <v-list-item-icon>
                              <v-icon v-text="'mdi-format-list-text'" color="primary"
                              v-if="index + 1 == categoryBreakpoint() + 1 &&
                                contentLength(card) > categoryBreakpoint()"
                              ></v-icon>
                              <v-icon 
                                color="primary" v-else-if="index<categoryBreakpoint()"
                                v-text="computedIcon(contenter.type)"
                              ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content
                              v-if="index + 1 <= categoryBreakpoint()"
                            >
                              <v-list-item-title  class="center"
                                v-text="contenter.title"
                              ></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content
                              v-if="
                                index + 1 == categoryBreakpoint() + 1 &&
                                contentLength(card) > categoryBreakpoint()
                              ">
                              <v-list-item-title class="center"
                                v-text="
                                  'And ' +
                                  (contentLength(card) - index) +
                                  ' more...'
                                "
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>

                      <v-card-actions v-if="card.include_footer">
                        <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-bookmark</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-share-variant</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar
        v-model="selected_content_snackbar"
        vertical
        :timeout="selected_content_timeout"
        :centered="true"
      >
        The <strong>{{ selected_content.type }}</strong> with the title:
        <strong>"{{ selected_content.title }}"</strong> will open in a new
        window with menu links for that that category.
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="selected_content_snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
    <v-footer :dark="theme" padless>
      <v-card-text class="py-2  text-center"
      :class="theme ? 'white--text':'black--text'">
      
        <v-img
          lazy-src="@/assets/logo.png"
          height="45"
          max-height="45"
          min-height="45"
          contain
          aspect-ratio="1"
          v-bind:src="imgr"
        ></v-img>

        <div style="justify-content='right'">
          <span
            >Copyright {{ new Date().getFullYear() }} —
            <a
              class="bubbalink"
              :class="theme ? 'white--text':'black--text'"
              style="text-decoration: none"
              href="https://fyi.io"
              target="_blank"
              >Powered by fyiio</a
            ></span
          >
        </div>
      </v-card-text>
    </v-footer>
  </v-card>
</template>
<script>
import SearchIndex from "./SearchIndex.vue";
import kbMixin from "./KnowledgeBaseMixin.js";
import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { gql } from "@apollo/client/core";
import config from "../config";
export default {
  components: {
    SearchIndex,
  },
  mixins: [kbMixin],
  mounted() {
    //let self = this;
    this.client = new ApolloClient({
      uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
      cache: new InMemoryCache(),
      headers: {},
    });
    this.cdn = `${process.env.VUE_APP_KB_CDN}`;
    if (this.$route.params.id != undefined) {
      this.id = this.$route.params.id.trim();
      console.log(
        "Id exists, attempting to retrieve. If any issues, will set up for new."
      );
      this.findKnowledgeBaseById(this.id);
    } else {
      //Display error
    }
  },
  data: () => ({
    aspect_ratio:1.0,
    //selected_content_snackbar
    selected_content_snackbar: false,
    selected_content_timeout: 4000,
    placeholder_img: "placeholder.jpg",
    //end selected_content_snackbar
    id: "",
    theme:false,
    organization_id: "",
    componentKey: 0,
    cdn: "",
    former: {
      title: "Knowledge Base Title",
      description: "Subheader (optional info)",
    },
    button1: {},
    dialog:false, 
    button2: {},
    cards: [],
    real_cards: new Map(),
    client: {},
    img_hold: "",
    selected_categories: [],
    category_items: [],
    selected_content: "",
  }),
  watch: {
    selected_content(valzer) {
      //if content from the same category is chosen, reuse the window, otherwise, open a new window.
      window.open(
        `/kbs/v/${this.$route.params.id}/${valzer.category_id}/${valzer.content_id}`,
        valzer.category_id
      );
    },
  },
  computed: {
    imgr: function () {
      console.log("org id", this.organization_id)
      if (
        this.img_hold == "" ||
        this.img_hold == null ||
        this.organization_id == "" ||
        this.organization_id ==undefined
      ) {
        return `${this.cdn}${this.placeholder_img}`;
      } else {
        let url= `${this.cdn}${config.RETRIEVE_FILEPATH_CDN}/${this.organization_id}/${this.img_hold}`;
        this.getImageMeta(url)
        return url
      }
    },
  },
  methods: {
    filterAware(card_content){
      let self=this;
      let filteredContent=card_content.filter((content, index)=>{return index<(self.categoryBreakpoint()+1)})
      return filteredContent
    },
    buttonInfo: function (button) {
      window.open(button.link, "_blank");
    },
    getImageMeta(url){   
        var img = new Image();
        let self=this;
        img.addEventListener("load", function(){
            console.log( this.naturalWidth +' '+ this.naturalHeight );
            if(this.naturalWidth>this.naturalHeight){
              console.log("returning: ", 16/9)
              self.aspect_ratio=(16/9)
            }else{
              console.log("returing: ", 1)
              self.aspect_ratio=1
            }
            self.$forceUpdate()
        });
        img.src = url;  
    },
    //put in kbmixin
    categoryBreakpoint() {
      if (this.mobile) {
        return 3;
      } else if (this.medium) {
        return 4;
      } else if (this.large) {
        return 5;
      } else {
        return 4;
      }
    },
    /*eslint-disable no-unused-vars */
    computeColumns(flex, idx) {
      switch (this.cards.length) {
        case 1:
          return 12;
        case 2:
        case 4:
          return 6;
        case 3:
        case 6:
          return 4;
        default:
          return 12;
      }
    },
    contentLength(card) {
      if (card.content) {
        return card.content.length;
      } else {
        return 0;
      }
    },
    processCategoriesIntoCards(categories) {
      let self = this;
      categories.forEach((category) => {
        let catter = {};
        catter.id = category.category.id;
        catter.title = category.category.title;
        catter.description = category.category.description;
        catter.src = "";
        catter.flex = 12;
        catter.heighter = "370px";
        catter.include_footer = false;
        (catter.include_gradient = true),
          (catter.content = category.category.content);
        this.real_cards.set(catter.id, catter);
        this.category_items.push({
          title: `${catter.title}`,
          id: `${catter.id}`,
        });
      });
      this.page_categories_loaded = true;
      this.categoriesEmit(self.selected_categories);
    },
    categoriesEmit(valzer) {
      console.log("after the emit: ", valzer);
      let hold = valzer.map((cat) => {
        return cat.id;
      });
      //hold.push("bubba");
      console.log("after the map", hold);
      let cardReplacer = new Map();

      this.cards.forEach((card) => {
        if (hold.includes(card.id)) {
          console.log("adding_:", card.id);
          cardReplacer.set(card.id, card);
        }
      });
      //now add in any newly selected categories
      this.real_cards.forEach((card) => {
        console.log("Real cards:", card.id);
        if (hold.includes(card.id)) {
          //console.log("adding_rc:", card.id);
          cardReplacer.set(card.id, card);
        }
      });
      this.cards = [...cardReplacer.values()];
      console.log("cards:", this.cards);
    },

    findKnowledgeBaseById(id) {
      let self = this;
      this.client
        .query({
          query: gql`
            query GetKnowledgeBase($id: uuid!) {
              knowledge_base_by_pk(id: $id) {
                id
                title
                description
                created_at
                header_buttons
                organization_id
                published
                logo
                dark_theme
                categories(order_by: { order: asc }) {
                  category_id
                  category {
                    id
                    title
                    content
                  }
                  include_footer
                  include_gradient
                }
              }
            }
          `,
          variables: {
            id: id,
          },
        })
        .then((result) => {
          console.log("knowledgebase:", result.data);
          let kb = result.data.knowledge_base_by_pk;
          let published = kb.published;
          if (!published){
            this.dialog=true;
          }
          if (kb.header_buttons) {
            this.button1 = kb.header_buttons.header_button_1;
            this.button2 = kb.header_buttons.header_button_2;
          } else {
            console.log("No buttons defined, using the defaults.");
          }
          if (kb.categories) {
            self.selected_categories = [];
            kb.categories.forEach((category) => {
              console.log("categories loop", category.category);
              self.selected_categories.push({
                id: category.category.id,
                title: category.category.title,
              });
            });
            this.processCategoriesIntoCards(kb.categories);
          }
          this.organization_id = kb.organization_id;
          this.former.title = kb.title;
          this.former.description = kb.description;
          this.theme=kb.dark_theme
          this.custom_domain = kb.custom_domain;
          this.custom_domain_verified = kb.custom_domain_verified;
          this.img_hold = kb.logo;
          this.overlay = false;
          this.componentKey += 1;
          this.$forceUpdate()
        });
    },
  },
};
</script>
<style scoped>
.center {
display: flex;
justify-content: center;
}
.bubbalink:hover {
  font-weight: bold;
}
</style>